const Widget = () => {
  return <div>change password</div>;
};

export default Widget;
